export { usersActions } from "./actions";

export { UsersActionTypes } from "./actionTypes";
export { UsersMutationTypes } from "./mutationTypes";
export { UsersGetterTypes } from "./getters";

import { users } from "./modules";
export default users;
